import React from 'react'
import TestApi from '../TestApi'

export default function TestPage() {
    return(
        <div>
            <TestApi></TestApi>
        </div>
    )
}